import { post } from 'generic/api/apiGenerator';
import handleComplete from 'generic/utils/apiUtils';

const summarize = ({ ...rest }) => post({ path: '/summarize', ...rest }).then(handleComplete);

export default summarize;
